import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { AppStringsService } from 'src/app/_services';

@Component({
    selector: 'app-score-card-info-dialog',
    imports: [CommonModule, MatDialogModule, MatIconModule],
    templateUrl: './score-card-info-dialog.component.html',
    styleUrl: './score-card-info-dialog.component.scss'
})
export class ScoreCardInfoDialogComponent {
    constructor(public appStrings: AppStringsService) {}
}
